import { render, staticRenderFns } from "./NewOrderListItem.vue?vue&type=template&id=5f4a9524&scoped=true&"
import script from "./NewOrderListItem.vue?vue&type=script&lang=js&"
export * from "./NewOrderListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a9524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f4a9524')) {
      api.createRecord('5f4a9524', component.options)
    } else {
      api.reload('5f4a9524', component.options)
    }
    module.hot.accept("./NewOrderListItem.vue?vue&type=template&id=5f4a9524&scoped=true&", function () {
      api.rerender('5f4a9524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/NewOrderListItem.vue"
export default component.exports